import { clearStorageForLogout } from '@tcc/shared-data-lib';
import wam from '@tcc/wam';

export function getUserData() {
  try {
    return wam.getUserData();
  } catch {
    return null;
  }
}

export function reAuthenticate() {
  return wam.reAuthenticate();
}

export function logout() {
  clearStorageForLogout({ includeSessionStorage: true });
  wam.logout();
}
